import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

export let form =
{
	model: 'public',
	name: 'public',

	form_title: 'Public',

	fields:
	{
		'label':
		{
			label: 'Libellé'
		}
	},

	create_label: 'Créer ce public',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce public&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['public[label]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau public <strong> { model.name } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/publics/' + model.id }>
						Voir le public
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export let list =
{
	model         : 'public',
	title         : 'Liste des publics',
	link          : '/configuration/publics',
	creation_link : '/configuration/nouveau-public',
	creation_label: 'Nouveau public',
	header_map    :
	{
		'Libellé': 'label'
	},
	row_link_base : '/configuration/publics/',
	searched_prop : 'label'
}

let config = mergeDeep({ }, form);

config = mergeDeep(config, list);

export default config;